import { EvaluationShow } from 'pages/professor_area/classrooms/components/TabEvaluations/Evaluation/EvaluationShow';
import { IResource } from 'interfaces/resources';
import { generateResources } from 'utils/GenerateResouces';

const resource: IResource = {
  name: 'professor_area/classroom_assessments',
  pathTemplate: 'professor_area/classrooms/:classroomId/evaluations',
  label: 'Avaliações',
  show: EvaluationShow,
  actions: ['list', 'show', 'create', 'edit', 'delete'],
  parentName: 'professor_area',
  route: 'professor_area/classrooms/:classroomId/assessments'
};

export default generateResources(resource);
